import React, { useState, useEffect, useRef } from 'react'

import { Button, Dialog, Grid, Icon, Typography, Select, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import useStyles from "./styles";
import { Label, CustomBtn, DraggableComponent } from "../../../components/UiElements/UiElements";
import { PostDataAPI } from '../../../../src/Services/PostDataAPI';
import { GetUserInfo } from '../../../../src/Services/GetUserInfo';
import DialogLoader from '../../../components/Loader/DialogLoader';
import { withSnackbar } from "./../../../components/Message/Alert";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


function PrintDonation({ dialogOpenClose, handleClose, handleSuccessClose, htmlContent, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [loading, setLoading] = useState(false);
    const contentRef = useRef(null);
    const handlePrintReceipt = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.open();
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        const printTimeout = setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 1000);
        //Clear the timeout when the component unmounts to prevent memory leaks
        return () => clearTimeout(printTimeout);
    }
    const handlePrint = () => {
        const input = contentRef.current;

        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            pdf.addImage(imgData, 'PNG', 10, 10);
            pdf.save('document.pdf');

            // Initiate the print dialog
            pdf.autoPrint();
        });
    };
    useEffect(() => {

    }, []);
    return (
        <>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableEscapeKeyDown
                open={dialogOpenClose}
                PaperComponent={DraggableComponent}
                maxWidth="md"
                {...props} >
                <div className={classes.activeDialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>View Print</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>

                        <Scrollbars autoHeight autoHeightMax={540}>
                            <div className={classes.content}>
                                <Grid row xl={12} md={12} sm={12} lg={12} className={classes.paddingLeftRight}>
                                    <div ref={contentRef}>
                                        <div dangerouslySetInnerHTML={{ __html: htmlContent }}/>
                                    </div>
                                       
                                </Grid>

                            </div>
                        </Scrollbars>

                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                                <Button className={classes.backBtn} onClick={handlePrintReceipt}>Print</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default withSnackbar(PrintDonation);